// ** React Imports
import { NavLink } from "react-router-dom";

// ** Third Party Components
import classnames from "classnames";
import { useTranslation } from "react-i18next";

// ** Reactstrap Imports
import { Badge } from "reactstrap";
import { notNullString } from "@src/utility/StringUtil";

import SetaBaixo from "src/assets/images/pages/setaparabaixo.svg";

// import { MenuType } from "@src/@types/MenuITypes";
// import { Icon } from "react-feather";

// interface VerticalNavMenuLinkProps {
//   item : MenuType,
//   activeItem: string
// }

const VerticalNavMenuLink = ({ item, activeItem, menuCollapsed, menuHover }) => {

  const LinkTag = item.externalLink ? "a" : NavLink;

  // ** Hooks
  const { t } = useTranslation();

  // LOGICA PARA SABER SE O MENU ESTA EXPANDIDO
  const isExpanded = menuHover || !menuCollapsed;

  return (
    <li
      className={classnames({
        "nav-item-new": !item.children,
        disabled: item.disabled,
        active: item.navLink === activeItem,
      })}
    >
      <LinkTag
        target={item.newTab ? "_blank" : "_self"}
        {...(item.externalLink === true
          ? { href: item.navLink || "/" }
          : {
              to: item.navLink || "/",
              className: ({ isActive }) => {
                const baseClass = "d-flex align-items-center";
                const alignmentClass = isExpanded ? "" : "justify-content-center";
                return isActive && !item.disabled ? `${baseClass} ${alignmentClass} active` : `${baseClass} ${alignmentClass}`;
              },
            })}
        onClick={(e) => {
          if (item.navLink.length === 0 || item.navLink === "#" || item.disabled === true) {
            e.preventDefault();
          }
        }}
      >
        {item.icon}

        {isExpanded && (
          <span className="menu-item text-truncate style-menu-item">
            {t("verticalMenu." + notNullString(item.title).toLocaleLowerCase())}
          </span>
        )}

        {isExpanded && item.badge && item.badgeText ? (
          <Badge className="ms-auto me-1" color={item.badge} pill>
            {item.badgeText}
          </Badge>
        ) : null}
      </LinkTag>
    </li>
  );
};

export default VerticalNavMenuLink;